import {
	Component,
	OnInit,
	ViewEncapsulation,
	Input,
	OnDestroy,
	EventEmitter,
	Output,
	AfterViewInit
} from "@angular/core";
import { IdService } from "../shared/services/id.service";

import { IMediaCardArticle } from "./media-card.interface";

@Component({
	selector: "rbc-media-card",
	templateUrl: "./media-card.component.html",
	styles: [],
	encapsulation: ViewEncapsulation.None
})
export class MediaCardComponent implements OnInit, OnDestroy {
	@Input() id: string;
	@Input() scrollMobile = false;
	@Input() linksAlignStart = false;
	@Input() divider = false;
	@Input() card = false;
	@Input() columns: string;
	@Input() headingTag: "h2" | "h3" | "h4" | "h5" | "h6" = "h5";
	@Input() layout:
		| "stacked-vertical"
		| "stacked-horizontal"
		| "featured-stacked"
		| "featured-stacked-horizontal"
		| "featured-tile";
	@Input() articles: IMediaCardArticle[];
	@Input() linkIconType;
	// @Input() title;
	@Input() hoverable = false;

	@Output() ctaLinkClicked = new EventEmitter();

	constructor(private idService: IdService) { }

	ngOnInit() {
		if (!this.id) {
			this.id = this.idService.generate();
		}
	}

	ngOnDestroy(): void {
		if (this.idService) {
			this.idService.remove(this.id);
		}
	}

	containerClasses() {
		const { layout, scrollMobile, articles } = this;
		return {
			row: this.columnsGen(),
			"rbc-media-card-tiles": layout === "featured-tile",
			"rbc-media-card-featured-stacked": layout === "featured-stacked",
			"rbc-media-card-featured-stacked-horizontal":
				layout === "featured-stacked-horizontal",
			"rbc-media-card-scroll":
				articles && articles.length > 1 && scrollMobile
		};
	}

	columnsClasses(index) {
		const { layout, divider, card } = this;
		const columnResult = this.columnsGen();
		const columnResultIndex = this.columnsGen(index);

		return {
			[`col-lg-${12 / columnResultIndex}`]: columnResult,
			"col-md-6": columnResultIndex >= 2 && layout !== "featured-stacked",
			"rbc-card-col-my": card,
			"rbc-media-card-divider": !card && divider
		};
	}

	columnsGen(index?): any {
		const { layout, columns } = this;
		if (layout === "featured-tile") {
			if (index === 0) {
				return 1.5;
			} else {
				return 3;
			}
		} else if (layout === "featured-stacked") {
			return 2;
		} else if (layout === "featured-stacked-horizontal") {
			return;
		} else if (columns) {
			return columns;
		} else {
			return;
		}
	}

	articleColoredClasses(article) {
		return {
			// "rbc-media-card-footer": !article.linkIcon && article.linkText && !article.footerAuthors,
			"rbc-media-card-colored-overlay-translucent": article.image,
			[`b-${article.backgroundColor}`]: article.backgroundColor
		};
	}

	articleImageClasses(article) {
		return {
			"rbc-media-card-image-content":
				!article.colored && (article.imageText || article.imageIcon),
			[`b-${article.imageBackgroundColor}`]: article.imageBackgroundColor,
			[`c-${article.imageTextColor}`]: article.imageTextColor
		};
	}

	articleCategoryClasses(article) {
		return {
			[`c-${article.categoryColor}`]: article.categoryColor
		};
	}

	cardTypeGen(index?) {
		const { articles, layout } = this;
		if (
			articles[index].stacked === "horizontal" ||
			layout === "stacked-horizontal" ||
			(layout === "featured-stacked" && index !== 0) ||
			(layout === "featured-stacked-horizontal" && index !== 0) ||
			(layout === "featured-tile" && index === 0)
		) {
			return "horizontal";
		} else {
			return "vertical";
		}
	}

	showFooter(article) {
		return (
			((article.linkText || article.linkIcon) && article.link) ||
			(article.footerAuthors && article.footerAuthors.length) ||
			article.footerByline ||
			(article.footerLinks && article.footerLinks.length) ||
			article.actionMenu
		);
	}

	cardFooterGen(article) {
		let classes = {};
		// tslint:disable-next-line:max-line-length
		// [ngClass] = "{'rbc-media-card-footer': !article.linkIcon && article.linkText && !article.footerAuthors}"
		// classes["rbc-media-card-footer"] = !article.linkIcon && article.linkText && !article.footerAuthors
		classes["rbc-media-card-footer"] = (!article.linkIcon && article.linkText && !article.footerAuthors) || (!this.card && article.footerLinksLabel && !article.linkText) || (!article.footerAuthors && article.linkIcon) || (article.footerAuthors);
		classes["rbc-media-card-footer-large"] = (!this.card && article.footerLinksLabel && !article.linkText) || (article.footerAuthors);
		classes["rbc-media-card-footer-start"] = article.linkButton || this.linksAlignStart;

		// (article.footerAuthors && article.footerAuthors.length) ||
		// 	article.footerByline ||
		// 	(article.footerLinks && article.footerLinks.length),


		return classes;
	}

	linkClicked(event) {
		this.ctaLinkClicked.emit(event);
	}
}
